import { TopologyPageWrapper } from "@flanksource-ui/components/Topology/TopologyPageWrapper";

export function TopologyPage() {
  return <TopologyPageWrapper catalogTab="Catalog" />;
}
